import { render } from "./editarCliente.vue?vue&type=template&id=35e9f446&scoped=true"
import script from "./editarCliente.vue?vue&type=script&lang=js"
export * from "./editarCliente.vue?vue&type=script&lang=js"

import "./editarCliente.vue?vue&type=style&index=0&id=35e9f446&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-35e9f446"]])

export default __exports__